import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "create-alerts" }
const _hoisted_2 = { class: "quantity" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Título do alerta"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Data limite"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para o documento ser apreciado.", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_10 = { class: "quantity" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Descrição"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Descreva em uma frase curta as informações desse alerta.", -1)
const _hoisted_13 = { class: "spacing" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_15 = { for: "stats" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal-date-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Data limite"),
  /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para ser aceito.")
], -1)

import AlertModel from '@/models/AlertModel'
import { computed, ref } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import { useAxios } from '@/api/axios'
import { toast } from 'vue3-toastify'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAlertsView',
  setup(__props) {

const axios = useAxios()
const payload = ref<Partial<AlertModel>>({})
const selectedLimitDate = ref('')
const isLimitDateModalOpen = ref(false)
const isCreatingAlert = ref(false)
const formattedLimitDate = computed(() => payload.value.limit_date ? formatDate(payload.value.limit_date) : undefined)

function createAlert () {
  isCreatingAlert.value = true

  axios.post('/api/alerts', { ...payload.value, status: payload.value.status ? 'active' : 'inactive' })
    .then(() => {
      payload.value = {}
      toast.success('Alerta criado com sucesso')
    })
    .finally(() => isCreatingAlert.value = false)
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day}/${mouth}/${year}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        maxlength: 100,
        type: "text",
        placeholder: "Ex: Envio de informações de folha",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.title) = $event))
      }, null, 512), [
        [_vModelText, payload.value.title]
      ]),
      (payload.value.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(payload.value.title.length) + "/100", 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, "0/100"))
    ]),
    _createElementVNode("section", null, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("label", {
        class: "date-picker-label",
        for: "limit_date",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isLimitDateModalOpen.value = true))
      }, [
        _createElementVNode("input", {
          type: "text",
          placeholder: "Selecione uma data",
          name: "limit_date",
          value: formattedLimitDate.value ? formattedLimitDate.value : '',
          id: "limit_date",
          readonly: ""
        }, null, 8, _hoisted_8),
        _hoisted_9
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _withDirectives(_createElementVNode("textarea", {
        name: "",
        id: "",
        cols: "30",
        rows: "10",
        placeholder: "Ex: As informações para a folha precisam ser enviadas até o dia 20 de cada mês.",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.description) = $event))
      }, null, 512), [
        [_vModelText, payload.value.description]
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("label", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "stats",
          id: "stats",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.status) = $event))
        }, null, 512), [
          [_vModelCheckbox, payload.value.status]
        ]),
        _hoisted_16
      ])
    ]),
    _createElementVNode("nav", null, [
      (!isCreatingAlert.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            value: "Enviar",
            onClick: createAlert,
            disabled: !payload.value.title || !payload.value.limit_date || !payload.value.description
          }, null, 8, _hoisted_17))
        : (_openBlock(), _createBlock(SpinnerLoaderButton, {
            key: 1,
            height: 60,
            maxWidth: 464
          })),
      _createElementVNode("input", {
        type: "button",
        value: "Cancelar",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.go(-1)))
      })
    ]),
    _createVNode(MyModal, {
      width: '341px !important',
      height: '517px !important',
      className: 'date-limit',
      isOpen: isLimitDateModalOpen.value,
      toggleModal: (v) => isLimitDateModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_18,
        _createVNode(MyDatePicker, {
          min: { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() },
          name: 'limit',
          setValue: (date) => selectedLimitDate.value = date
        }, null, 8, ["min", "setValue"]),
        _createElementVNode("input", {
          type: "button",
          value: "Aplicar data",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {payload.value.limit_date = selectedLimitDate.value; isLimitDateModalOpen.value = false})
        })
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})